import updateClass from '../css/updateClass';
import updateStyleByRef from '../css/updateStyleByRef';
//import getDefaultStyle from '../css/defaultStyle';
import cloneDeep from 'lodash-es/cloneDeep';
import merge from 'lodash-es/merge';
import each from 'lodash-es/each';
import get from 'lodash-es/get';
import omit from 'lodash-es/omit';
import isEqual from 'lodash-es/isEqual';
import lookAndFeel from '../lookAndFeel';
import frameProps from '../css/frameProps';
const deepProps = [
    'color',
    'cursor',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontWeight',
    'textAlign',
    'whiteSpace',
    'textDecoration'
];
const mainCSS = [
  {
    selector: '&>.body',
    properties: {
      position: 'absolute',
      borderColor: 'rgba(255,255,255,0.2)',
      borderStyle: 'solid',
      borderWidth: '1px',
      backgroundColor: '${schemeSysBackground}',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,

      overflow: 'auto',
    },
  },
  {
    selector: '&>.body>table',
    properties: {
      borderCollapse: 'collapse',
      position: 'relative',
      borderColor: 'rgba(255,255,255,0)',
      // borderRadius: '0px',
      borderStyle: 'none',
      borderWidth: '0px',
      width: '100%',
    },
  },
  {
    selector: '&>.body>.empty-label',
    properties: {
      fontStyle: 'italic',
      opacity: 0.5,
      textAlign: 'center',
      padding:'8px'
    },
  },
];

updateClass(
  'io-grid-default-style',
  updateStyleByRef(cloneDeep(mainCSS), lookAndFeel()),
  '.io-grid-default'
);

// Properties from headerRowStyle that must also be applied to TH cells to win
// over the static-header default `tr.header>th { background-color: ${schemeSysBackground} }`.
// TR backgrounds are painted behind TH cells, so without these overrides the user's
// header background/hover never shows through.
const headerThOverlayProps = ['backgroundColor', 'background', 'backgroundImage'];

const rowCSS = [
  {
    //normal
    selector: '&>.body>table>tr',
    properties: {},
  },
  {
    //even (placeholder)
    selector: '',
    properties: {
      //backgroundColor: 'rgba(255,255,255,0.025)',
    },
  },
  {
    //hover
    selector: '&>.body>table>tr:hover',
    properties: {
      backgroundColor: 'rgba(255,255,255,0.05)',
    },
  },
  {
    //header normal
    selector: '&>.body>table>tr.header',
    properties: {
      color: '#FFFFFF',
      borderWidth: '0px 0px 1px 0px',
      borderStyle: 'solid',
      borderColor: 'rgba(255,255,255,0.2)',
    },
  },
  {
    //header hover
    selector: '&>.body>table>tr.header:hover',
    properties: {
      backgroundColor: 'rgba(255,255,255,0.0)',
    },
  },
  {
    //selected
    selector: '&>.body>table>tr.selected',
    properties: {
      backgroundColor: 'rgba(255,255,255,0.05)',
    },
  },
  {
    // header TH normal — background overlay so user-supplied headerRowStyle.normal.backgroundColor
    // wins over the static-header default applied to th.
    selector: '&>.body>table>tr.header>th',
    properties: {},
  },
  {
    // header TH hover — same as above for hover.
    selector: '&>.body>table>tr.header:hover>th',
    properties: {},
  },
];

const rowDeepCSS = [
  {
    //normal
    selector: '&>.body>table>tr *',
    properties: {},
  },
  {
    //even (placeholder)
    selector: '',
    properties: {
      //backgroundColor: 'rgba(255,255,255,0.025)',
    },
  },
  {
    //hover
    selector: '&>.body>table>tr:hover *',
    properties: {
      
    },
  },
  {
    //header normal
    selector: '&>.body>table>tr.header *',
    properties: {
      
    },
  },
  {
    //header hover
    selector: '&>.body>table>tr.header:hover *',
    properties: {
      
    },
  },
  {
    //selected
    selector: '&>.body>table>tr.selected *',
    properties: {
      
    },
  },
];

updateClass(
  'io-grid-row-default-style',
  updateStyleByRef(cloneDeep(rowCSS), lookAndFeel()),
  '.io-grid-default'
);

const columnCSS = [
  {
    selector: '&>.body>table>tr>td',
    properties: {
      padding: '8px',
      textAlign: 'left',
      //borderWidth: '1px',
      //borderStyle: 'solid',
      fontWeight: 'normal',
      // height: 'auto',
      // width: 'auto',
    },
  },
  {
    selector: '&>.body>table>tr.header>th',
    properties: {
      textAlign: 'left',
      padding: '8px',
      //borderWidth: '1px',
      //borderStyle: 'solid',
      fontWeight: 'bold',
      // height: 'auto',
      // width: 'auto',
    },
  },
  {
    selector: '&>.body>table>tr:hover>td',
    properties: {},
  },
  {
    selector: '&>.body>table>tr.selected>td',
    properties: {},
  },
];

updateClass(
  'io-grid-column-default-style',
  updateStyleByRef(cloneDeep(columnCSS), lookAndFeel()),
  '.io-grid-default'
);

updateClass(
  'io-grid-static-header-style',
  updateStyleByRef([
    {
      selector: '&>.body>table>tr.header',
      properties: 'position: sticky; top: 0; z-index: 2;',
    },
    {
      selector: '&>.body>table>tr.header>th',
      properties: 'position: sticky; top: 0; background-color: ${schemeSysBackground};',
    },
    {
      // Contain in-row controls (callout, choices, contextMenu use zIndex 100500)
      // so they can't paint over the sticky header during scroll.
      selector: '&>.body>table>tr:not(.header)',
      properties: 'isolation: isolate;',
    },
  ], lookAndFeel()),
  '.io-grid-default.static-header'
);

// Resizable columns. Opt-in via gridOptions.resizableColumns. Switches the
// table to table-layout:fixed so explicit widths are honoured exactly (and
// row content doesn't reflow column widths). Adds a 6px drag handle on the
// right edge of every <th> wired up in grid.js to update the column's TH
// width inline. Body cells inherit the TH width automatically under
// table-layout:fixed, so no per-TD work is needed.
updateClass(
  'io-grid-resizable-style',
  updateStyleByRef([
    {
      selector: '&>.body>table',
      properties: 'table-layout: fixed;',
    },
    {
      selector: '&>.body>table>tr.header>th',
      properties: 'position: relative; overflow: hidden; text-overflow: ellipsis;',
    },
    {
      selector: '&>.body>table>tr>td',
      properties: 'overflow: hidden; text-overflow: ellipsis;',
    },
    {
      selector: '&>.body>table>tr.header>th>.qos-col-resize',
      properties: 'position: absolute; top: 0; right: 0; width: 6px; height: 100%; cursor: col-resize; background: transparent; user-select: none; z-index: 3;',
    },
    {
      selector: '&>.body>table>tr.header>th>.qos-col-resize:hover',
      properties: 'background: rgba(95,168,255,0.35);',
    },
    {
      // While a drag is in progress the grid root carries this class so we
      // can darken the active handle and lock the cursor globally.
      selector: '&.col-resizing',
      properties: 'cursor: col-resize;',
    },
    {
      selector: '&.col-resizing *',
      properties: 'cursor: col-resize !important; user-select: none !important;',
    },
  ], lookAndFeel()),
  '.io-grid-default.resizable-columns'
);

const cssStyle = (instance) => {
  const res = {
    normal: {
      position: 'absolute',
      overflow: 'visible',
    },

    hover: {},
    
  };

  return res;
};

function createElement(instance) {
  const element = document.createElement('div');
  element.classList.add('io-grid-default');
  element.classList.add('controls');
  //element.classList.add('layout-container');
  element.innerHTML = '<div class="body"><table></table><div class="empty-label"></div></div>';
  return element;
}

export default {
  cssClass: {
    main: mainCSS,
    row: rowCSS,
    column: columnCSS,
  },
  cssStyle,
  createElement,
  options: {
    layout: 'custom',
    showSampleRow: true,
    style: {
      normal: {},
      dragOver:{
        boxShadow: '0px 0px 8px 0px ${schemeForegroundHover}'
      }
    },
    emptyLabel:{
      text: 'No Data',
      name: '',
      type: 'label',
      style:{
        fontStyle: 'italic',
        opacity: 0.5,
        textAlign: 'center',
        padding:8
      }
    }
  },
  updateGridClasses: function(control, options) {
    let normal = get(options, 'style.normal');    
    let dragOver = control.isDragOver?get(options, 'style.dragOver'):{};    
    let empty = get(options, 'emptyLabel.style');
    // let title = get(options, 'title.style.normal');
    let scheme = lookAndFeel(options.lookAndFeel, normal.height);
    let CSS = updateStyleByRef(
      merge(cloneDeep(mainCSS), [
        {
          // body
          properties: omit(merge({},normal,dragOver), frameProps),
        },{},
        {
          properties: omit(empty, frameProps),
        }
      ]),
      scheme
    );

    if (isEqual(control.CSS, CSS)) {
      return;
    }

    control.CSS = CSS;
    control.styleSheet = updateClass(control.styleSheet, CSS, '#' + control.id);
  },

  updateRowClasses: function(control, options) {
    const columns = options.columns || [];
    let hasHeader = columns.some((col) => col.header);
    let rowNormal = get(options, 'rowStyle.normal', {});
    let rowSelected = get(options, 'rowStyle.selected', {});
    let rowEven = merge(
      {
        backgroundColor: 'rgba(255,255,255,0.025)',
      },
      get(options, 'rowStyle.even')
    );
    let rowHover = get(options, 'rowStyle.hover');
    let headNormal = get(options, 'headerRowStyle.normal');
    let headHover = get(options, 'headerRowStyle.hover');
    // let title = get(options, 'title.style.normal');
    let scheme = lookAndFeel(options.lookAndFeel, rowNormal.height);
    let CSS = updateStyleByRef(
      merge(cloneDeep(rowCSS), [
        {
          properties: rowNormal,
        },
        {
          selector: `.body>table>tr:nth-of-type(${hasHeader ? '2n+3' : '2n'})`,
          properties: rowEven,
        },
        {
          properties: rowHover,
        },
        {
          properties: headNormal,
        },
        {
          properties: headHover,
        },
        {
          properties: rowSelected,
        },
        {
          properties: _.pick(headNormal || {}, headerThOverlayProps),
        },
        {
          properties: _.pick(headHover || {}, headerThOverlayProps),
        },
      ]),
      scheme
    );

    if (!isEqual(control.rowCSS, CSS)) {
      control.rowCSS = CSS;
      control.styleSheetRow = updateClass(control.styleSheetRow, CSS, '#' + control.id);
    }

    let deepCSS = updateStyleByRef(
      merge(cloneDeep(rowDeepCSS), [
        {
          properties: _.pick(rowNormal,deepProps),
        },
        {
          selector: `.body>table>tr:nth-of-type(${hasHeader ? '2n+3' : '2n'}) *`,
          properties: _.pick(rowEven,deepProps),
        },
        {
          properties: _.pick(rowHover,deepProps),
        },
        {
          properties: _.pick(headNormal,deepProps),
        },
        {
          properties: _.pick(headHover,deepProps),
        },
        {
          properties: _.pick(rowSelected,deepProps),
        },
      ]),
      scheme
    );

    if (!isEqual(control.rowDeepCSS, deepCSS)) {
      control.rowDeepCSS = deepCSS;
      control.styleSheetDeepRow = updateClass(control.styleSheetDeepRow, deepCSS, '#' + control.id);
    }
  },
  updateGridColumnClasses: function(control, columns) {
    let CSS = [];
    let hasHeader = (columns || []).some((col) => col.header);
    each(columns, (options, pos) => {
      let normal = get(options, 'style.normal', {});
      let hover = get(options, 'style.hover', {});
      let selected = get(options, 'style.selected', {});
      let header = merge({}, normal, get(options, 'headerStyle.normal'));
      if (!hasHeader) {
        header.display = 'none';
      }

      let scheme = lookAndFeel(options.lookAndFeel, normal.height);
      CSS = CSS.concat(
        updateStyleByRef(
          merge(cloneDeep(columnCSS), [
            {
              // body
              selector: `${columnCSS[0].selector}:nth-of-type(${pos + 1})`,
              properties: normal,
            },
            {
              // header
              selector: `${columnCSS[1].selector}:nth-of-type(${pos + 1})`,
              properties: header,
            },
            {
              selector: `${columnCSS[2].selector}:nth-of-type(${pos + 1})`,
              properties: hover,
            },
            {
              selector: `${columnCSS[3].selector}:nth-of-type(${pos + 1})`,
              properties: selected,
            },
          ]),
          scheme
        )
      );
    });

    if (isEqual(control.columnsCSS, CSS)) {
      return;
    }

    control.columnsCSS = CSS;
    control.styleSheetColumn = updateClass(control.styleSheetColumn, CSS, '#' + control.id);
  },
};
